export default __webpack_public_path__ + "static/about_contact_bg_tn-c59091ad8728c2ed73d307cee14b79a0.png";